// extracted by mini-css-extract-plugin
export default {"intercomContainer":"styles_intercomContainer__t-VVi","addIntercomButton":"styles_addIntercomButton__Jeesv"};